/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MatrixPossibilityDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: MatrixPossibilityDefinitionDto.source;
    label?: string;
    value?: number;
}

export namespace MatrixPossibilityDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
